export enum PAGINATION_ELEMENT_TYPE {
  prev = 'prev',
  next = 'next',
  jumpNext = 'jump-next',
  jumpPrev = 'jump-prev',
}
